import Cookies from 'js-cookie';
import React, { useEffect, useMemo } from 'react';
import { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { Toast } from '../components/common/toast';
import { getSingleLocale, getUserLang } from '../utils/utils';

const PageContext = React.createContext({
    locale: [],
    handleChangeLanguage: (locale) => null,
});

export const PageContextProvider = ({ pageContext, children }) => {
    const { t, i18n } = useTranslation();
    const lanaguageSelected = Cookies.get('language');

    const [locale, setLocale] = React.useState(getUserLang(lanaguageSelected).langs);

    useEffect(() => {
        const pageLang = getSingleLocale(pageContext?.lang || 'en');

        if (pageContext.lang !== i18n.language) {
            i18n.changeLanguage(pageContext.lang);
        }

        const languagesWithOutFirst = locale.slice(1);

        if (pageLang !== locale[0] && languagesWithOutFirst.includes(pageLang)) {
            Toast({
                message: t('toast.change', 'Do you want to change the language?'),
                options: pageContext?.languageSupported,
            });
        } else if (pageLang !== locale[0] && !languagesWithOutFirst.includes(pageLang)) {
            Toast({
                message: t('toast.appologies', 'Sorry, this page is not available in your language. we are working on it.'),
                options: pageContext?.languageSupported,
            });
        }
    }, [pageContext?.lang]);

    const handleChangeLanguage = (lang) => {
        const newLocale = getUserLang(lang).langs;
        setLocale(newLocale);
    };

    const value = useMemo(
        () => ({
            ...pageContext,
            handleChangeLanguage,
            locale,
        }),
        [],
    );

    return (
        <PageContext.Provider value={value}>
            <div>
                <Toaster
                    toastOptions={{
                        // Define default options
                        className: '',
                        duration: 3000,
                    }}
                />
                {children}
            </div>
        </PageContext.Provider>
    );
};

export const usePageContext = () => React.useContext(PageContext);
